import React from "react";

function Warning({ width = 20, height = 20, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2472_61003)">
        <path
          d="M0.833496 17.4998H19.1668L10.0002 1.6665L0.833496 17.4998ZM10.8335 14.9998H9.16683V13.3332H10.8335V14.9998ZM10.8335 11.6665H9.16683V8.33317H10.8335V11.6665Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2472_61003">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Warning;
